import api from "./api.js";

export default class FaqApi {
  static async create(data) {
    return await api.post(`faq`, data);
  }
  static async getList(params) {
    return await api.get(`faq`, params);
  }
  static async getById(faqId, params) {
    return await api.get(`faq/${faqId}`, params);
  }
  static async update(faqId, data) {
    return await api.patch(`faq/${faqId}`, data);
  }
  static async delete(data) {
    return await api.del(`faq`, data);
  }
}
